
import { defineComponent, PropType } from 'vue'

import { FTLOrderStatus } from '@/core/types/orders.types'

import { formatDateWithTimeFromBackend, formatDateFromBackend } from '@/common/helpers/formatDate'

export default defineComponent({
    props: {
        statuses: {
            type: Array as PropType<FTLOrderStatus[]>,
            default: () => [],
        },
    },
    setup() {
        return {
            formatDateWithTimeFromBackend,
            formatDateFromBackend
        }
    }
})
